export default __webpack_public_path__ + "static/media/measure.9c600cea.png";